import { styled } from '@glitz/react';
import * as React from 'react';
import Image from 'webapp/components/image';
import { addNavigationEventToDataLayer, type NavigationEvent } from 'webapp/tracking/events/main-navigation';
import { useFlyout } from 'webapp/shell/flyout-context';
import Link from 'webapp/components/Link';
import { overflowEllipsisDecorator } from 'webapp/decorators/text';

type Props = {
  menuItem: NordicNest.Api.MenuItemApiModel;
  compact?: boolean;
  navigationData?: NavigationEvent;
};

export const IconLink = styled(({ menuItem, compact = false, navigationData }: Props) => {
  const { close } = useFlyout('Menu');

  return (
    <Base
      to={menuItem.link.to}
      onClick={() => {
        close();
        navigationData && addNavigationEventToDataLayer({ ...menuItem, ...navigationData });
      }}
      css={compact && compactDecorator}
    >
      {menuItem.icon && <Icon image={menuItem.icon} />}
      <Title css={!compact && marginDecorator}>{menuItem.link.children}</Title>
    </Base>
  );
});

const Icon = styled(Image, {
  height: 28,
  width: 28,
  objectFit: 'contain',
});

const Base = styled(Link, {
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  padding: { x: t => t.spacing.s, y: t => t.spacing.xs },
});

const compactDecorator = styled({
  display: 'grid',
  gridTemplateColumns: '24px 1fr',
  columnGap: t => t.spacing.l,
  padding: { x: t => t.spacing.l },
});

const Title = styled.div({
  textDecoration: 'none',
});

const marginDecorator = styled(overflowEllipsisDecorator, {
  margin: { top: t => t.spacing.s },
  textAlign: 'center',
});
